import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import BusinessIcon from '@mui/icons-material/Business';
import ArticleIcon from '@mui/icons-material/Article';
import sectorText from 'assets/images/sector-footer.png';
import goUp from 'assets/images/goUp.svg';
import soorinLogo from 'assets/images/soorinlogo.png';
import logo from 'assets/images/sectorLogos/columnLogo.svg';
import footerbg from 'assets/images/illustrations/footer.svg';
import style from './Footer.module.scss';
import { InstaIcon, TwitterIcon, FacebookIcon } from 'Sui_Icons';

export const Footer = () => {
  const handleSamandehiClick = () => {
    window.open(
      "https://logo.samandehi.ir/Verify.aspx?id=392054&p=xlaopfvluiwkobpddshwaods",
      "Popup",
      "toolbar=no,scrollbars=no,location=no,statusbar=no,menubar=no,resizable=0,width=450,height=630,top=30"
    );
  };

  return (
    <Container maxWidth="xxl">
      <Box
        sx={{
          background: 'white',
          backgroundImage: `url(${footerbg})`,
          backgroundPosition: 'revert',
          position: 'relative',
          mt: 20,
          flex: 1,
          minHeight: '200px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <img src={sectorText} className={style.sectorText} alt="sector-footer" />

        <Box sx={{ maxWidth: { xs: 66, lg: 86 }, mt: 4, mb: 2 }}>
          <img src={logo} className={style.logo} alt="sector-logo" />
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'row', my: 1 }}>
          <Button sx={{ color: 'GrayText', fontSize: '14px' }}>درباره ما</Button>
          <Button sx={{ color: 'GrayText', fontSize: '14px' }}>سوالات متداول</Button>
          <Button sx={{ color: 'GrayText', fontSize: '14px' }}>قوانین و مقررات</Button>
        </Box>

        {/* Soorin Contact Information Section - NEW ROW */}
        <Box
          sx={{
            width: '93%',
            mt: 3,
            p: 4,
            borderRadius: 2,
            backgroundColor: '#0F2441',
          }}
        >
          <Typography 
            fontSize="24px" 
            fontWeight="700" 
            color="primary.main"
            textAlign="center"
            gutterBottom
          >
            تیم  سکتور همیشه همراه شماست
          </Typography>

          {/* Contact Cards Row */}
          <Box 
            sx={{ 
              display: 'flex', 
              flexDirection: { xs: 'column', lg: 'row' },
              gap: 3,
              mt: 3
            }}
          >
            {/* Email Section */}
            <Box 
              sx={{ 
                flex: 1,
                display: 'flex', 
                alignItems: 'center', 
                gap: 2,
                bgcolor: 'rgba(255,255,255,0.1)',
                p: 3,
                borderRadius: 2
              }}
            >
              <EmailIcon sx={{ color: '#05C6C5', fontSize: 40 }} />
              <Box>
                <Typography fontSize={16} fontWeight={700} color='#fff' gutterBottom>
                  مشاوره از طــریق ارســال ایمیــل
                </Typography>
                <Typography fontSize={14} color='#8EA7C6'>
                  info@soorinsec.ir
                </Typography>
              </Box>
            </Box>

            {/* Phone Section */}
            <Box 
              sx={{ 
                flex: 1,
                display: 'flex', 
                alignItems: 'center', 
                gap: 2,
                bgcolor: 'rgba(255,255,255,0.1)',
                p: 3,
                borderRadius: 2
              }}
            >
              <PhoneIcon sx={{ color: '#05C6C5', fontSize: 40 }} />
              <Box>
                <Typography fontSize={16} fontWeight={700} color='#fff' gutterBottom>
                  تمــاس بـا واحـد پشتیبـانی
                </Typography>
                <Typography fontSize={14} color='#8EA7C6'>
                  021-22021734
                </Typography>
              </Box>
            </Box>

            {/* Address Section */}
            <Box 
              sx={{ 
                flex: 1,
                display: 'flex', 
                alignItems: 'center', 
                gap: 2,
                bgcolor: 'rgba(255,255,255,0.1)',
                p: 3,
                borderRadius: 2
              }}
            >
              <BusinessIcon sx={{ color: '#05C6C5', fontSize: 40 }} />
              <Box>
                <Typography fontSize={16} fontWeight={700} color='#fff' gutterBottom>
                  آدرس سورین
                </Typography>
                <Typography fontSize={14} color='#8EA7C6'>
                  تهران، خیابان نلسون ماندلا، کوچه عاطفی غربی، پلاک ۸۵، واحد ۸
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* About Soorin Section - In Same Box */}
          <Box sx={{ mt: 3, p: 3, bgcolor: 'rgba(255,255,255,0.1)', borderRadius: 2 }}>
          <Typography gutterBottom>
              <Typography
                fontSize="20px"
                fontWeight="700"
                color="#fff"
                variant="h6"
                display="inline"
              >
                درباره
              </Typography>
              &nbsp;
              <Typography
                fontSize="20px"
                color="primary.main"
                fontWeight="700"
                variant="h6"
                display="inline"
              >
                سکتور
              </Typography>
            </Typography>
            <Typography fontSize={14} color='#8EA7C6' align='justify' sx={{ lineHeight: 2 }}>
            سکتور پلتفرم آموزشی بستری آنلاین است که به صورت تعاملی و بدون نیاز به معلم،
              مهم‌ترین نیازهای دنیای امنیت سایبری را به شما آموزش می‌دهد. علاوه بر بهره‌مندی از
              آموزش‌های تعاملی متنوع، امکان شرکت در آزمون و اخذ گواهینامه را با کمترین زمان و
              هزینه برای مخاطبان فراهم می‌سازد.
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', mt: 5 }}>
          {/* --- نماد اعتماد الکترونیکی --- */}
          <Box
            sx={{
              cursor: 'pointer',
              my: { xs: 4, lg: 0 },
              width: { xs: '100%', lg: '20%' },
              display: 'flex',
              justifyContent: 'space-around',
              '& img': { height: '70px', width: 'auto' },
            }}
          >
            <a
              target="_blank"
              href="https://trustseal.enamad.ir/?id=328325&Code=k4Q9d73BvIISPJFkO5TE"
              rel="noopener noreferrer"
            >
              <img
                className={style.nemad}
                src="https://trustseal.enamad.ir/logo.aspx?id=328325&Code=k4Q9d73BvIISPJFkO5TE"
                referrerPolicy="origin"
                alt="enamad-logo"
                style={{ cursor: 'pointer' }}
              />
            </a>
          </Box>

          {/* --- لوگوی ساماندهی --- */}
          <Box
            sx={{
              cursor: 'pointer',
              my: { xs: 4, lg: 0 },
              width: { xs: '100%', lg: '20%' },
              display: 'flex',
              justifyContent: 'space-around',
              '& img': { height: '70px', width: 'auto' },
            }}
          >
            <img
              referrerPolicy="origin"
              id="rgvjsizpnbqeesgtapfuwlao"
              style={{ cursor: 'pointer' }}
              onClick={handleSamandehiClick}
              alt="logo-samandehi"
              src="https://logo.samandehi.ir/logo.aspx?id=392054&p=qftibsiyodrflymaujynshwl"
            />
          </Box>
        </Box>
        </Box>

        {/* --- پایین فوتر --- */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', lg: 'row' },
            width: '93%',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: { xs: '100%', lg: '100%' },
              justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: { lg: 'space-between' },
                flex: { lg: 0.7 },
                flexDirection: { xs: 'column', lg: 'row' },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }} order={{ xs: 2, lg: 1 }}>
                <img src={soorinLogo} alt="soorin-logo" />
                <Typography align="left" color="#8EA7C6" sx={{ ml: 1 }}>
                  ساخته شده توسط سورین
                </Typography>
              </Box>
              <Box order={{ xs: 1, lg: 2 }}>
                <InstaIcon sx={{ mx: 2, cursor: 'pointer' }} fontSize="large" />
                <TwitterIcon sx={{ mx: 2, cursor: 'pointer' }} fontSize="large" />
                <FacebookIcon sx={{ mx: 2, cursor: 'pointer' }} fontSize="large" />
              </Box>
            </Box>

            <Box
              sx={{ mt: 2, maxHeight: '80px', overflow: 'hidden', cursor: 'pointer' }}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              <img src={goUp} alt="scroll-to-top" />
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};
